import { useCallback } from 'react';

const getFilename = (contentDisposition, fallback) => {
  if (!contentDisposition) return fallback;

  const filenameRegex = /filename\*?=(?:UTF-8''|")?([^;"\n]+)(?:"|$)/i;

  const match = contentDisposition.match(filenameRegex);

  if (match && match[1]) {
    return decodeURIComponent(match[1].trim());
  }

  return fallback;
};

export const useFileDownloader = () => {
  const downloadFile = useCallback((response, fallbackName = 'download') => {
    if (!response) return;

    const contentType = response?.headers?.['content-type'] || 'application/octet-stream';
    const disposition = response?.headers?.['content-disposition'] || '';

    // --- Extract filename from content-disposition ---
    const filename = getFilename(disposition, fallbackName);

    // --- Create Blob and download ---
    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename; // << ALWAYS USES filename from backend
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

    // console.log(`📥 Download started: ${filename}`);
  }, []);

  return { downloadFile };
};
